export const menuItems = [
  {
    key: "genel-bakis",
    value: "Genel Bakış",
  },
  {
    key: "ilan-hakkinda",
    value: "İlan Hakkında",
  },
  {
    key: "konum-bilgisi",
    value: "Konum Bilgisi",
  },
  {
    key: "fiyat-analizi",
    value: "Fiyat Analizi",
  },
  {
    key: "bolge-raporu",
    value: "Bölge Raporu",
  },
  {
    key: "firma-kunyesi",
    value: "Firma Künyesi",
  },
  {
    key: "onerilen-ilanlar",
    value: "Önerilen İlanlar",
  },
  // {
  //   key: "ek-faydalar",
  //   value: "Ek Faydalar",
  // },
];
